<template>
	<div class="row" v-show="!loading">
		<div class="col-md-4 col-md-offset-4">
			<div class="select-site">
				<h2>Please Select A Site</h2>

				<div class="wrap-fluid">
					<div class="row">
						<div class="col-lg-12">
							<div class="account-box">
								<form role="form" @submit.prevent="submit">
									<input-select
										:select2="true"
										:options="siteOptions"
										name="site"
										class=""
										:vmodel.sync="selected">
									</input-select>

									<hr />

									<button class="btn btn-sm btn-primary">Continue <i class="fa fa-chevron-right"></i></button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Sites as SiteActions, App as AppActions } from 'vx/actions'
	import { sites, loading } from 'vx/getters'
	import Router from 'routes'
	import store from 'vx/store';

	export default {
		data() {
			return {
				selected: null
			}
		},

		vuex: {
			actions: {
				all: SiteActions.all,
				select: SiteActions.select,
				setTitle: AppActions.title
			},
			getters: {
				sites,
				loading
			}
		},

		computed: {
			siteOptions() {
				return this.sites.map(site => {
					return { value: site.id, name: site.name };
				});
			}
		},

		ready() {
			this.setTitle('Site Selection');
		},

		route: {
			data() {
				this.$dispatch('loading');

				this.select({});

				this.all().then(() => {
					this.$dispatch('loaded');
				});
			}
		},

		methods: {
			submit() {
				let site = {};

				if (! this.sites) {
					return;
				}

				for (let i = 0; i < this.sites.length; ++i) {
					if (this.sites[i].id == this.selected) {
						site = this.sites[i];

						break;
					}
				}

				if (site == {}) {
					return;
				}

				this.select(site);

				this.$router.go({ name: 'dashboard' });
			}
		}
	}
</script>



// WEBPACK FOOTER //
// index.vue?79e1cbb6